import {
  AttachFile,
  Chat,
  Check,
  DoneAll,
  EditNotifications,
  Email,
  HourglassBottom,
  Image,
  MiscellaneousServices,
  MonitorHeart,
  AirlineSeatReclineNormal,
  TimeToLeave,
  Pending,
  People,
  HomeWork,
  Person,
  Phone,
  PhoneIphone,
  PriorityHigh,
  Sms,
  ThumbDown,
  ThumbUp,
  Tune,
  School,
  Description,
} from "@mui/icons-material";
import { endpoints, localUrlEnum, pathParams } from "./UrlEnum";
import PageNotFound from "../Components/PageNotFound";
import { Vocabulary } from "./Vocabulary";
import PrivateRoute from "../Router/PrivateRouter";
import DashboardContainer from "../Components/DashboardContainer";
import Login from "../Pages/LoginPage";
// import DashboardPage from "../Pages/Dashboard";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import ClientsTable from "../Components/Clients/ClientsTable";
import OnlineClientsTable from "../Components/Clients/OnlineClientsTable";
import SettingsIcon from "@mui/icons-material/Settings";
import UsersTable from "../Components/Users/UsersTable";
import OrdersTable from "../Components/Orders/OrdersTable";
import OrderStatus from "../Components/OrderStatus/OrderStatusesTable";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ViewListIcon from "@mui/icons-material/ViewList";
import Order from "../Components/Orders/Order";
import EmailTemplatesTable from "../Components/Templates/EmailTemplatesTable";
import OrderOfferPasswordPage from "../Pages/OrderOfferPasswordPage";
import OrderOfferConfirmPage from "../Pages/OrderOfferConfirmPage";
import WhatsAppIntegrationMainPage from "../Components/WhatsAppIntegration/WhatsAppIntegrationMainPage";
import WhatsAppTemplatesTable from "../Components/WhatsAppIntegration/WhatsAppTemplatesTable";
import { createTheme } from "@mui/material";
import {
  EAuditAction,
  EAuditStatus,
  EHeaderTemplateMenuOptions,
  ETemplateStatus,
  EWhatsAppComponentsTypes,
  EWhatsAppMessageType,
  EWhatsAppTemplateButtonType,
  EWhatsAppTemplateCategoryTranslation,
  OrderStatuses,
} from "./Enums";
import WhatsAppTemplateForm from "../Components/WhatsAppIntegration/WhatsAppTemplateForm";
import WhatsAppPhoneNumber from "../Components/WhatsAppIntegration/WhatsAppPhoneNumber";
import PhoneNumberRegistrationStep from "../Components/WhatsAppIntegration/PhoneNumberRegistrationStep";
import VerifyCodeConfirmationStep from "../Components/WhatsAppIntegration/VerifyCodeConfirmationStep";
import TwoFactorAuthenticationSetupStep from "../Components/WhatsAppIntegration/TwoFactorAuthenticationSetupStep";
import Messenger from "../Components/Messages/Messenger";
import LogsTable from "../Components/Logs/LogsTable";
import Client from "../Components/Clients/Client";
// import TasksTable from "../Components/Tasks/TasksTable";
import AlertsTable from "../Components/Alerts/AlertsTable";
import CertificateExamsTable from "../Components/Alerts/CertificateExamsTable";
import WorkPointsTable from "../Components/WorkPoints/WorkPointsTable";
import CompaniesTable from "../Components/Companies/CompaniesTable";
import InstructorsTable from "../Components/Instructors/InstructorsTable";
import VehiclesTable from "../Components/Vehicles/VehiclesTable";
import ServicesTable from "../Components/Services/ServicesTable";
import OrderForm from "../Components/Orders/OrderForm";
import ClassesTable from "../Components/Classes/ClassesTable";
import ClassClients from "../Components/Classes/ClassClients";
import RecommendationsTable from "../Components/Recommendations/RecommendationsTable";
import CashDeskTable from "../Components/Payments/CashDeskTable";
import Settings from "../Pages/Settings";
import AccountsTable from "../Components/Accounts/AccountsTable";
import ReportsTable from "../Components/Reports/ReportsTable";
import Groups2Icon from "@mui/icons-material/Groups2";
import FlagIcon from "@mui/icons-material/Flag";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import PersonIcon from "@mui/icons-material/Person";
import DepartureBoardIcon from "@mui/icons-material/DepartureBoard";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import PaymentsIcon from "@mui/icons-material/Payments";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScheduledExams from "../Components/Reminders/ScheduledExams";
import ScheduledExamsByType from "../Components/Exams/ScheduledExamsByType";
import ReminderCategoryExpiration from "../Components/Reminders/ReminderCategoryExpiration";
import FolderIcon from "@mui/icons-material/Folder";
import CarCrashIcon from "@mui/icons-material/CarCrash";
import CarDocumentsExpiration from "../Components/Reminders/CarDocumentsExpiration";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import UserDocumentsExpiration from "../Components/Reminders/UserDocumentsExpiration";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import AssignmentIcon from "@mui/icons-material/Assignment";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CoursesTable from "../Components/Courses/CoursesTable";
import ModulesTable from "../Components/Modules/ModulesTable";
import QuizIcon from "@mui/icons-material/Quiz";
import ExamSetsTable from "../Components/ExamQuestions/ExamSetsTable";
import ExamQuestionsTable from "../Components/ExamQuestions/ExamQuestionsTable";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import BooksTable from "../Components/Books/BooksTable";
import ExamsCalendar from "../Components/Exams/ExamsCalendar";
import DocumentTemplatesTable from "../Components/DocumentTemplates/DocumentTemplatesTable";
import SubscriptionsTable from "../Components/Subscriptions/SubscriptionsTable";
import DrivingHoursCalendar from "../Pages/DrivingHoursCalendar";
import DocumentValidity from "../Pages/DocumentValidity";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import EventIcon from "@mui/icons-material/Event";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import NotificationConfiguration from "../Pages/NotificationConfiguration";
import SmsClientsPage from "../Pages/SmsClientsPage";
import OnlineLessonsTable from "../Components/OnlineLessons/OnlineLessonsTable";
import OnlineLessonRoomPage from "../Components/OnlineLessons/OnlineLessonRoomPage";
import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SmsSentReportTable from "../Components/Reports/SmsSentReportTable";

export const HttpStatusCode = {
  OK: 200,
  Created: 201,
  Accepted: 202,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  RequestTimeout: 408,
  Conflict: 409,
  InternalServerError: 500,
  NotImplemented: 501,
  UnprocessableEntity: 422,
};

export const DATA_TYPES = {
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  OBJECT: "object",
} as const;

export const resourcePaths = {
  tasks: "/tasks",
};

export const HttpVerbs = {
  post: "post",
  get: "get",
  put: "put",
  delete: "delete",
  patch: "patch",
};

export const SortOptions = {
  asc: "asc",
  desc: "desc",
};

export const PaymentMethods = {
  CASH: "Cash",
  BANK: "Bancar",
  POS: "POS",
};

export const PaymentType = {
  INCOME: "Incasare",
  PAYMENT: "Plata",
  WITHDRAW: "Retragere",
};

export const PaymentOptions = {
  NORMAL: "Plata normala",
  RETURN: "Returnare",
};

export const PaymentMessages = {
  REFUND_DESCRIPTION:
    "Am rambursat suma de {amount} RON cursantului {clientName}",
};

export const OrderSource = {
  ONLINE: "online",
  MANUAL: "manual",
};

export const ScanDocumentType = {
  ID: "ID",
  ID_BACK: "IDBack",
  DRIVER_LICENSE: "DriverLicense",
  DRIVER_LICENSE_BACK: "DriverLicenseBack",
};

export const OCREndpoints = {
  [ScanDocumentType.ID]: "/api/ocr/identity/extract",
  [ScanDocumentType.ID_BACK]: "/api/ocr/identity-back/extract",
  [ScanDocumentType.DRIVER_LICENSE]: "/api/ocr/driving-license/extract",
  [ScanDocumentType.DRIVER_LICENSE_BACK]:
    "/api/ocr/driving-license-back/extract",
};

// Slugs that identify ID card document types — add new slugs here as needed
export const ID_DOCUMENT_SLUGS = ["buletin", "ci", "buletin-electronic", "carte-identitate","idCard"];

export const NOTIFICATION_CONFIG = {
  notificationType: "",
  sendEmail: true,
  sendNotification: true,
  sendSMS: false,
  roles: [],
  selectedUsers: [],
  isActive: true,
};

export const WhatsAppMenuItems = [
  {
    name: Vocabulary.phoneNumber,
    path: localUrlEnum.whatsAppPhoneNumbers,
    icon: <PhoneIphone />,
  },
  {
    name: Vocabulary.templates,
    path: localUrlEnum.whatsAppTemplates,
    icon: <Chat />,
  },
];

export const ReportsTypes = {
  INSTRUCTOR_CLIENTS: "instructorClients",
  CLIENTS_INSTRUCTOR: "clientsInstructor",
  ORDER_STATUSES: "orderStatuses",
  WORK_POINTS: "workPoints",
  CLIENTS: "clients",
  INSTRUCTOR_TIMESHEET: "instructorTimesheet",
  COMPANY: "company",
  USER_ACTIONS: "userActions",
  USER_SALARY: "userSalary",
  DRIVING_HOURS: "drivingHours",
  CLIENT_PAYMENTS: "clientPayments",
  PASS_RATE: "passRate",
};

export const MainSliderData = [
  // {
  //   name: Vocabulary.dashboard,
  //   path: localUrlEnum.dashboard,
  //   icon: <Dashboard />,
  // },
  {
    name: Vocabulary.dashboard,
    path: localUrlEnum.orders,
    icon: <ViewListIcon />,
  },
  {
    name: Vocabulary.referrals,
    path: localUrlEnum.recommendations,
    icon: <ViewListIcon />,
  },
  {
    name: Vocabulary.reports,
    icon: <ViewListIcon />,
    children: [
      {
        name: Vocabulary.reportsInstructorClients,
        path: `${localUrlEnum.reports}/${ReportsTypes.INSTRUCTOR_CLIENTS}`,
        icon: <Groups2Icon color="primary" />,
      },
      {
        name: Vocabulary.reportsOrderStatuses,
        path: `${localUrlEnum.reports}/${ReportsTypes.ORDER_STATUSES}`,
        icon: <FlagIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsCompany,
        path: `${localUrlEnum.reports}/${ReportsTypes.COMPANY}`,
        icon: <EmojiTransportationIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsWorkPoints,
        path: `${localUrlEnum.reports}/${ReportsTypes.WORK_POINTS}`,
        icon: <HomeWorkIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsClients,
        path: `${localUrlEnum.reports}/${ReportsTypes.CLIENTS}`,
        icon: <PersonIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsUserActions,
        path: `${localUrlEnum.reports}/${ReportsTypes.USER_ACTIONS}`,
        icon: <AssignmentIndIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsInstructorTimesheet,
        path: `${localUrlEnum.reports}/${ReportsTypes.INSTRUCTOR_TIMESHEET}`,
        icon: <DepartureBoardIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsUserSalary,
        path: `${localUrlEnum.reports}/${ReportsTypes.USER_SALARY}`,
        icon: <PaymentsIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsDrivingHours,
        path: `${localUrlEnum.reports}/${ReportsTypes.DRIVING_HOURS}`,
        icon: <QueryBuilderIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsClientsInstructors,
        path: `${localUrlEnum.reports}/${ReportsTypes.CLIENTS_INSTRUCTOR}`,
        icon: <FolderSharedIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsClientPayments,
        path: `${localUrlEnum.reports}/${ReportsTypes.CLIENT_PAYMENTS}`,
        icon: <AttachMoneyIcon color="primary" />,
      },
      {
        name: Vocabulary.reportsSmsReport,
        path: localUrlEnum.smsReport,
        icon: <Sms color="primary" />,
      },
      {
        name: Vocabulary.reportsPassRate,
        path: `${localUrlEnum.reports}/${ReportsTypes.PASS_RATE}`,
        icon: <EmojiEventsIcon color="primary" />,
      },
    ],
  },
  {
    name: Vocabulary.alerts,
    icon: <ViewListIcon />,
    children: [
      {
        name: Vocabulary.scheduledExams,
        path: `${localUrlEnum.scheduledExams}`,
        icon: <CalendarMonthIcon color="primary" />,
      },
      {
        name: Vocabulary.certificateExams,
        path: localUrlEnum.certificateExams,
        icon: <AssignmentIcon color="primary" />,
      },
      {
        name: Vocabulary.reminderCategoryExpiration,
        path: `${localUrlEnum.reminderCategoryExpiration}`,
        icon: <FolderIcon color="primary" />,
      },
      {
        name: Vocabulary.reminderCarDocuments,
        path: `${localUrlEnum.reminderCarDocumentsExipiration}`,
        icon: <CarCrashIcon color="primary" />,
      },
      {
        name: Vocabulary.reminderUserDocuments,
        path: `${localUrlEnum.reminderUserDocumentsExpiration}`,
        icon: <ContactEmergencyIcon color="primary" />,
      },
    ],
  },
  {
    name: Vocabulary.cashDesk,
    path: localUrlEnum.cashDesk,
    icon: <ViewListIcon />,
  },
  {
    name: Vocabulary.instructors,
    path: localUrlEnum.instructors,
    icon: <AirlineSeatReclineNormal />,
  },
  // {
  //   name: Vocabulary.scheduleDrivingHours,
  //   path: localUrlEnum.scheduleDrivingHours,
  //   icon: <AirlineSeatReclineNormal />,
  // },
  {
    name: Vocabulary.onlineClients,
    path: localUrlEnum.onlineClients,
    icon: <Diversity3Icon />,
  },
  {
    name: Vocabulary.clientCourses,
    path: localUrlEnum.clientCourses,
    icon: <Diversity3Icon />,
    children: [
      {
        name: Vocabulary.courses,
        path: localUrlEnum.courses,
        icon: <CollectionsBookmarkIcon color="primary" />,
      },
      {
        name: Vocabulary.modules,
        path: localUrlEnum.modules,
        icon: <MenuBookIcon color="primary" />,
      },
      {
        name: Vocabulary.examSet,
        path: localUrlEnum.examSets,
        icon: <QuizIcon color="primary" />,
      },
      {
        name: Vocabulary.examQuestions,
        path: localUrlEnum.examQuestions,
        icon: <QuestionMarkIcon color="primary" />,
      },
    ],
  },
  {
    name: Vocabulary.books,
    path: localUrlEnum.books,
    icon: <MenuBookIcon />,
  },
  {
    name: Vocabulary.tools,
    path: "",
    icon: <Tune />,
    children: [
      {
        name: Vocabulary.systemSettings,
        path: localUrlEnum.settings,
        icon: <People />,
      },
      {
        name: Vocabulary.users,
        path: localUrlEnum.users,
        icon: <People />,
      },
      {
        name: Vocabulary.classes,
        path: localUrlEnum.classes,
        icon: <MonitorHeart />,
      },
      {
        name: Vocabulary.vehicles,
        path: localUrlEnum.vehicles,
        icon: <TimeToLeave />,
      },
      {
        name: Vocabulary.services,
        path: localUrlEnum.services,
        icon: <School />,
      },
      {
        name: Vocabulary.workPoints,
        path: localUrlEnum.workPoints,
        icon: <HomeWork />,
      },
      {
        name: Vocabulary.subscriptions,
        path: localUrlEnum.subscriptions,
        icon: <AttachMoneyIcon />,
      },
      {
        name: Vocabulary.ordersStatuses,
        path: localUrlEnum.orderStatus,
        icon: <ChecklistIcon />,
      },
      {
        name: Vocabulary.documentTemplates,
        path: localUrlEnum.documentTemplates,
        icon: <FileOpenIcon />,
      },
      {
        name: Vocabulary.examsCalendar,
        path: localUrlEnum.examsCalendar,
        icon: <EventIcon />,
      },
      {
        name: Vocabulary.onlineLessons,
        path: localUrlEnum.onlineLessons,
        icon: <VideoCameraFrontIcon />,
      },
      {
        name: Vocabulary.scheduleDrivingHours,
        path: localUrlEnum.drivingHoursCalendar,
        icon: <CalendarMonthIcon />,
      },

      {
        name: Vocabulary.alerts,
        path: localUrlEnum.alerts,
        icon: <EditNotifications />,
      },
      {
        name: Vocabulary.smsClientsMenu,
        path: localUrlEnum.smsClients,
        icon: <Sms />,
      },
      {
        name: Vocabulary.logs,
        path: localUrlEnum.logs,
        icon: <MonitorHeart />,
      },
    ],
  },
];

export const MainSliderDataForUser = [
  {
    name: Vocabulary.dashboard,
    path: localUrlEnum.orders,
    icon: <ViewListIcon />,
  },
  {
    name: Vocabulary.angajati,
    path: localUrlEnum.angajati,
    icon: <AirlineSeatReclineNormal />,
  },
  {
    name: Vocabulary.onlineClients,
    path: localUrlEnum.onlineClients,
    icon: <Diversity3Icon />,
  },
  {
    name: Vocabulary.classes,
    path: localUrlEnum.classes,
    icon: <MonitorHeart />,
  },
  {
    name: Vocabulary.vehicles,
    path: localUrlEnum.vehicles,
    icon: <TimeToLeave />,
  },
  {
    name: Vocabulary.alerts,
    icon: <ViewListIcon />,
    children: [
      {
        name: Vocabulary.scheduledExams,
        path: `${localUrlEnum.scheduledExams}`,
        icon: <CalendarMonthIcon color="primary" />,
      },
      {
        name: Vocabulary.certificateExams,
        path: localUrlEnum.certificateExams,
        icon: <AssignmentIcon color="primary" />,
      },
      {
        name: Vocabulary.reminderCategoryExpiration,
        path: `${localUrlEnum.reminderCategoryExpiration}`,
        icon: <FolderIcon color="primary" />,
      },
      {
        name: Vocabulary.reminderCarDocuments,
        path: `${localUrlEnum.reminderCarDocumentsExipiration}`,
        icon: <CarCrashIcon color="primary" />,
      },
      {
        name: Vocabulary.reminderUserDocuments,
        path: `${localUrlEnum.reminderUserDocumentsExpiration}`,
        icon: <ContactEmergencyIcon color="primary" />,
      },
    ],
  },
  {
    name: Vocabulary.books,
    path: localUrlEnum.books,
    icon: <MenuBookIcon />,
  },
  {
    name: Vocabulary.cashDesk,
    path: localUrlEnum.cashDesk,
    icon: <ViewListIcon />,
  },
  {
    name: Vocabulary.onlineLessons,
    path: localUrlEnum.onlineLessons,
    icon: <VideoCameraFrontIcon />,
  },
  {
    name: Vocabulary.scheduleDrivingHours,
    path: localUrlEnum.drivingHoursInstructor,
    icon: <QueryBuilderIcon />,
  },
];

const MainSliderDataForInstructorsBase = [
  {
    name: Vocabulary.dashboard,
    path: localUrlEnum.orders,
    icon: <ViewListIcon />,
  },
  {
    name: Vocabulary.onlineLessons,
    path: localUrlEnum.onlineLessons,
    icon: <VideoCameraFrontIcon />,
  },
  {
    name: Vocabulary.scheduledTheoreticalExams,
    path: `${localUrlEnum.scheduledExamsByType.replace(
      ":type",
      "theoretical",
    )}`,
    icon: <CalendarMonthIcon color="primary" />,
  },
  {
    name: Vocabulary.scheduledPracticalExams,
    path: `${localUrlEnum.scheduledExamsByType.replace(":type", "practical")}`,
    icon: <CalendarMonthIcon color="primary" />,
  },
  {
    name: `${Vocabulary.drivingHours}`,
    path: localUrlEnum.drivingHoursInstructor,
    icon: <QueryBuilderIcon color="primary" />,
  },
  {
    name: Vocabulary.documentValidity,
    path: localUrlEnum.documentValidity,
    icon: <Description color="primary" />,
  },
];

/**
 * Get filtered menu data for instructors based on canScheduleHours permission
 * @returns Filtered menu array for instructors
 */
export const getMainSliderDataForInstructors = () => {
  const canScheduleHours = localStorage.getItem("canScheduleHours");

  // If canScheduleHours is not "true", filter out the driving hours calendar item
  if (canScheduleHours !== "true") {
    return MainSliderDataForInstructorsBase.filter(
      (item) => item.path !== localUrlEnum.drivingHoursInstructor,
    );
  }

  return MainSliderDataForInstructorsBase;
};

export const ClientExcelHeader = [
  "CLIENT",
  "CATEGORIE",
  "SAPTAMANA",
  "COD_FISCAL",
  "NR_REGISTRU_COMERT",
  "OBSERVATII",
  "ADRESA",
  "ORAS",
  "JUDET",
  "BANCA",
  "CONT_BANCAR",
  "TARA",
  "EMAIL",
  "PERSOANA_DE_CONTACT",
  "TELEFON",
];

export const ROLES = {
  ROLE_ADMINISTRATOR: "ROLE_ADMINISTRATOR",
  ROLE_USER: "ROLE_USER",
};

export const ComponentsNames = {
  MainSlider: "MainSlider",
  LocalRouter: "LocalRouter",
  MainHeader: "MainHeader",
  ContactsTable: "ContactsTable",
  Task: "Task",
  FileExplorerMin: "FileExplorerMin",
  GeneralInfo: "GeneralInfo",
  Order: "Order",
  ClientPanel: "ClientPanel",
};

export const SubtaskColumns = [
  {
    label: Vocabulary.fancyName,
    name: "text",
  },
  {
    label: Vocabulary.status,
    name: "status",
  },
];

export const AllRoutes = [
  { path: localUrlEnum.login, element: <Login /> },
  {
    path: `${localUrlEnum.orderOfferPasswordCheck}${pathParams.orderId}`,
    element: <OrderOfferPasswordPage />,
  },
  // {
  //   path: `${localUrlEnum.orderOffer}${pathParams.orderId}`,
  //   element: <OrderOfferPage />,
  // },
  {
    path: `${localUrlEnum.orderOfferConfirmation}${pathParams.orderId}`,
    element: <OrderOfferConfirmPage />,
  },
  {
    path: localUrlEnum.mainRoute,
    // element: <DashboardPage shouldRenderSearchBar={true} />,
    element: <PageNotFound text={Vocabulary.pageNotFound} />,
  },
  {
    path: localUrlEnum.mainRoute,
    element: (
      <PrivateRoute>
        <DashboardContainer name="DashboardContainer" />
      </PrivateRoute>
    ),
    children: [
      // {
      //   path: localUrlEnum.dashboard,
      //   element: <DashboardPage shouldRenderSearchBar={true} />,
      // },
      {
        path: localUrlEnum.recommendations,
        element: <RecommendationsTable />,
      },
      {
        path: localUrlEnum.cashDesk,
        element: <CashDeskTable name="CashDeskTable" />,
      },
      {
        path: `${localUrlEnum.reports}${pathParams.reportsType}`,
        element: <ReportsTable name={"ReportsTable"} />,
      },
      {
        path: localUrlEnum.smsReport,
        element: <SmsSentReportTable name="SmsSentReportTable" />,
      },
      {
        path: localUrlEnum.users,
        element: <UsersTable />,
      },
      {
        path: localUrlEnum.workPoints,
        element: <WorkPointsTable />,
      },
      {
        path: localUrlEnum.company,
        element: <CompaniesTable />,
      },
      {
        path: localUrlEnum.clients,
        element: <ClientsTable nam="ClientsTable" />,
      },
      {
        path: localUrlEnum.onlineClients,
        element: <OnlineClientsTable name="OnlineClientsTable" />,
      },
      {
        path: `${localUrlEnum.client}${pathParams.optionalId}`,
        element: <Client />,
      },
      {
        path: localUrlEnum.orders,
        element: <OrdersTable name="OrdersTable" />,
      },
      {
        path: localUrlEnum.newOrder,
        element: <OrderForm name="OrderForm" />,
      },
      {
        path: `${localUrlEnum.order}${pathParams.optionalId}`,
        element: <Order />,
      },
      // {
      //   path: localUrlEnum.tasks,
      //   element: <TasksTable />,
      // },
      {
        path: localUrlEnum.settings,
        element: <Settings />,
      },
      {
        path: `${localUrlEnum.logs}${pathParams.optionalId}`,
        element: <LogsTable />,
      },
      {
        path: `${localUrlEnum.classes}${pathParams.optionalId}`,
        element: <ClassesTable name="ClassesTable" />,
      },
      {
        path: localUrlEnum.classClients,
        element: <ClassClients />,
      },
      {
        path: `${localUrlEnum.alerts}${pathParams.optionalId}`,
        element: <AlertsTable />,
      },
      {
        path: localUrlEnum.certificateExams,
        element: <CertificateExamsTable name="CertificateExamsTable" />,
      },
      {
        path: localUrlEnum.orderStatus,
        element: <OrderStatus />,
      },

      {
        path: localUrlEnum.whatsAppPhoneNumbers,
        element: <WhatsAppIntegrationMainPage />,
        children: [{ path: "", element: <WhatsAppPhoneNumber /> }],
      },
      {
        path: localUrlEnum.whatsAppTemplates,
        element: <WhatsAppIntegrationMainPage />,
        children: [{ path: "", element: <WhatsAppTemplatesTable /> }],
      },
      {
        path: `${localUrlEnum.whatsAppTemplate}${pathParams.optionalId}`,
        element: <WhatsAppIntegrationMainPage />,
        children: [{ path: "", element: <WhatsAppTemplateForm /> }],
      },
      {
        path: localUrlEnum.emailTemplates,
        element: <EmailTemplatesTable />,
      },
      {
        path: `${localUrlEnum.messages}${pathParams.optionalId}`,
        element: <Messenger />,
      },
      {
        path: localUrlEnum.instructors,
        element: <InstructorsTable name="InstructorsTable" />,
      },
      {
        path: localUrlEnum.angajati,
        element: <InstructorsTable name="InstructorsTable" />,
      },
      {
        path: localUrlEnum.vehicles,
        element: <VehiclesTable />,
      },
      {
        path: localUrlEnum.services,
        element: <ServicesTable />,
      },
      {
        path: localUrlEnum.accounts,
        element: <AccountsTable />,
      },
      {
        path: localUrlEnum.scheduledExams,
        element: <ScheduledExams />,
      },
      {
        path: localUrlEnum.scheduledExamsByType,
        element: <ScheduledExamsByType />,
      },
      {
        path: localUrlEnum.drivingHoursInstructor,
        element: <DrivingHoursCalendar name="DrivingHoursCalendar" />,
      },
      {
        path: localUrlEnum.documentValidity,
        element: <DocumentValidity />,
      },
      {
        path: localUrlEnum.reminderCategoryExpiration,
        element: <ReminderCategoryExpiration />,
      },
      {
        path: localUrlEnum.reminderCarDocumentsExipiration,
        element: <CarDocumentsExpiration name="CarDocumentsExpiration" />,
      },
      {
        path: localUrlEnum.reminderUserDocumentsExpiration,
        element: <UserDocumentsExpiration />,
      },
      {
        path: localUrlEnum.courses,
        element: <CoursesTable />,
      },
      {
        path: localUrlEnum.modules,
        element: <ModulesTable name="ModulesTable" />,
      },
      {
        path: localUrlEnum.examSets,
        element: <ExamSetsTable name="ExamSetsTable" />,
      },
      {
        path: localUrlEnum.examQuestions,
        element: <ExamQuestionsTable name="ExamQuestionsTable" />,
      },
      {
        path: localUrlEnum.books,
        element: <BooksTable name="BooksTable" />,
      },
      {
        path: localUrlEnum.onlineLessons,
        element: <OnlineLessonsTable />,
      },
      {
        path: localUrlEnum.onlineLessonRoom,
        element: <OnlineLessonRoomPage />,
      },
      {
        path: localUrlEnum.subscriptions,
        element: <SubscriptionsTable />,
      },
      {
        path: localUrlEnum.documentTemplates,
        element: <DocumentTemplatesTable name="DocumentTemplatesTable" />,
      },
      {
        path: localUrlEnum.examsCalendar,
        element: <ExamsCalendar />,
      },
      {
        path: localUrlEnum.drivingHoursCalendar,
        element: <DrivingHoursCalendar name="DrivingHoursCalendar" />,
      },
      {
        path: localUrlEnum.notificationConfiguration,
        element: <NotificationConfiguration />,
      },
      {
        path: localUrlEnum.smsClients,
        element: <SmsClientsPage />,
      },
    ],
  },
  {
    path: localUrlEnum.pageNotFound,
    element: <PageNotFound text={Vocabulary.pageNotFound} />,
  },
];

export const HeaderTemplateMenuOptions = [
  { label: "Fără", value: EHeaderTemplateMenuOptions.NONE },
  { label: "Text", value: EHeaderTemplateMenuOptions.TEXT },
  { label: "Imagine", value: EHeaderTemplateMenuOptions.IMAGE },
  { label: "Video", value: EHeaderTemplateMenuOptions.VIDEO },
  { label: "Document", value: EHeaderTemplateMenuOptions.DOCUMENT },
];

const AdminRouter = {
  routes: [
    localUrlEnum.login,
    localUrlEnum.mainRoute,
    localUrlEnum.pageNotFound,
    // localUrlEnum.dashboard,
    localUrlEnum.clients,
    localUrlEnum.onlineClients,
    `${localUrlEnum.client}${pathParams.optionalId}`,
    localUrlEnum.orderStatus,
    `${localUrlEnum.orderOfferPasswordCheck}${pathParams.orderId}`,
    `${localUrlEnum.orderOffer}${pathParams.orderId}`,
    `${localUrlEnum.orderOfferConfirmation}${pathParams.orderId}`,
    localUrlEnum.newOrder,
    localUrlEnum.orders,
    localUrlEnum.recommendations,
    localUrlEnum.cashDesk,
    `${localUrlEnum.reports}${pathParams.reportsType}`,
    `${localUrlEnum.order}${pathParams.optionalId}`,
    `${localUrlEnum.product}${pathParams.optionalId}`,
    localUrlEnum.users,
    localUrlEnum.workPoints,
    localUrlEnum.instructors,
    localUrlEnum.vehicles,
    localUrlEnum.services,
    localUrlEnum.company,
    localUrlEnum.emailTemplates,
    localUrlEnum.settings,
    `${localUrlEnum.logs}${pathParams.optionalId}`,
    `${localUrlEnum.alerts}${pathParams.optionalId}`,
    localUrlEnum.certificateExams,
    `${localUrlEnum.users}${pathParams.optionalId}`,
    localUrlEnum.whatsAppPhoneNumbers,
    localUrlEnum.whatsAppTemplates,
    `${localUrlEnum.whatsAppTemplate}${pathParams.optionalId}`,
    localUrlEnum.renderChildren,
    `${localUrlEnum.messages}${pathParams.optionalId}`,
    `${localUrlEnum.classes}${pathParams.optionalId}`,
    localUrlEnum.classClients,
    localUrlEnum.accounts,
    localUrlEnum.scheduledExams,
    localUrlEnum.psychologicalDocumentExpiration,
    localUrlEnum.reminderCategoryExpiration,
    localUrlEnum.reminderCarDocumentsExipiration,
    localUrlEnum.reminderUserDocumentsExpiration,
    localUrlEnum.courses,
    localUrlEnum.modules,
    localUrlEnum.examSets,
    localUrlEnum.examQuestions,
    localUrlEnum.books,
    localUrlEnum.onlineLessons,
    localUrlEnum.onlineLessonRoom,
    localUrlEnum.subscriptions,
    localUrlEnum.examsCalendar,
    localUrlEnum.drivingHoursCalendar,
    localUrlEnum.documentTemplates,
    localUrlEnum.register,
    localUrlEnum.notificationConfiguration,
    localUrlEnum.smsClients,
    localUrlEnum.smsReport,
  ],
};

const UserRouter = {
  routes: [
    localUrlEnum.login,
    localUrlEnum.mainRoute,
    localUrlEnum.pageNotFound,
    // localUrlEnum.dashboard,
    localUrlEnum.clients,
    localUrlEnum.onlineClients,
    `${localUrlEnum.client}${pathParams.optionalId}`,
    localUrlEnum.orderStatus,
    `${localUrlEnum.orderOfferPasswordCheck}${pathParams.orderId}`,
    `${localUrlEnum.orderOffer}${pathParams.orderId}`,
    `${localUrlEnum.orderOfferConfirmation}${pathParams.orderId}`,
    localUrlEnum.products,
    localUrlEnum.orders,
    localUrlEnum.newOrder,
    // localUrlEnum.tasks,
    `${localUrlEnum.order}${pathParams.optionalId}`,
    `${localUrlEnum.product}${pathParams.optionalId}`,
    localUrlEnum.emailTemplates,
    localUrlEnum.whatsAppPhoneNumbers,
    localUrlEnum.whatsAppTemplates,
    `${localUrlEnum.whatsAppTemplate}${pathParams.optionalId}`,
    localUrlEnum.renderChildren,
    `${localUrlEnum.messages}${pathParams.optionalId}`,
    localUrlEnum.books,
    localUrlEnum.angajati,
    `${localUrlEnum.classes}${pathParams.optionalId}`,
    localUrlEnum.classClients,
    localUrlEnum.classes,
    localUrlEnum.vehicles,
    localUrlEnum.cashDesk,
    localUrlEnum.scheduledExams,
    localUrlEnum.psychologicalDocumentExpiration,
    localUrlEnum.reminderCategoryExpiration,
    localUrlEnum.reminderCarDocumentsExipiration,
    localUrlEnum.reminderUserDocumentsExpiration,
    localUrlEnum.certificateExams,
    localUrlEnum.onlineLessons,
    localUrlEnum.onlineLessonRoom,
    localUrlEnum.drivingHoursInstructor,
  ],
};

const InstructorRouter = {
  routes: [
    localUrlEnum.login,
    localUrlEnum.mainRoute,
    localUrlEnum.pageNotFound,
    localUrlEnum.orders,
    localUrlEnum.onlineLessons,
    localUrlEnum.onlineLessonRoom,
    `${localUrlEnum.order}${pathParams.optionalId}`,
    localUrlEnum.scheduledExams,
    localUrlEnum.scheduledExamsByType,
    localUrlEnum.drivingHoursInstructor,
    localUrlEnum.documentValidity,
  ],
};

export const RoleUI: { [key: string]: any } = {
  Admin: {
    MainSlider: {
      data: MainSliderData,
    },
    MainHeader: {
      data: MainSliderData,
      shouldRenderSearchBar: true,
    },
    LocalRouter: AdminRouter,
    ContactsTable: {
      bulkActionsAllowed: true,
      selectableRows: "multiple",
      hideOptions: false,
    },
    ClientPanel: {
      collectPaymentType: PaymentMethods.BANK,
      showCollectPaymentButton: true,
      restrictAccess: false,
      editPrice: true,
      editDrivingHours: true,
    },
    SupplimentaryHoursForm: {
      paymentMethods: [PaymentMethods.CASH, PaymentMethods.POS],
    },
    CashDeskTable: {
      showWithdrawButton: true,
      showDeleteButton: true,
    },
    InstructorsTable: {
      delete: true,
    },
    HoursPanel: {
      addHours: true,
      addSupplementaryHours: true,
    },
    GeneralInfo: {
      accessPayments: true,
      accessBooks: true,
    },
    OrdersTable: {
      hideAddButton: false,
      showDeleteButton: true,
      showDownloadButton: true,
      showPrintButton: true,
    },
    ClientsTable: {
      showDeleteButton: true,
    },
    BooksTable: {
      delete: true,
    },
    DocumentsManager: {
      delete: true,
    },
  },
  Functionar: {
    MainSlider: {
      data: MainSliderDataForUser,
    },
    MainHeader: {
      data: MainSliderDataForUser,
      shouldRenderSearchBar: true,
    },
    ContactsTable: {
      hideOptions: true,
    },
    LocalRouter: UserRouter,
    Order: {
      test: "hihi agent",
    },
    ClientPanel: {
      collectPaymentType: [PaymentMethods.POS, PaymentMethods.CASH],
      showCollectPaymentButton: true,
      editDrivingHours: true,
    },
    SupplimentaryHoursForm: {
      paymentMethods: [PaymentMethods.CASH, PaymentMethods.POS],
    },
    BooksTable: {
      restrictByWorkPoint: true,
      delete: false,
    },
    SellBookButton: {
      restrictByWorkPoint: true,
      paymentMethods: [PaymentMethods.CASH, PaymentMethods.POS],
    },
    SellBookForm: {
      paymentMethods: [PaymentMethods.CASH, PaymentMethods.POS],
    },
    PaymentForm: {
      paymentMethods: [PaymentMethods.CASH, PaymentMethods.POS],
      restrictByWorkPoint: true,
    },
    PaymentFormSalary: {
      paymentMethods: [PaymentMethods.CASH, PaymentMethods.POS],
      restrictByWorkPoint: true,
    },
    CashDeskTable: {
      showWithdrawButton: false,
      restrictByWorkPoint: true,
      paymentMethods: [PaymentMethods.CASH, PaymentMethods.POS],
      paymentTypes: [
        PaymentType.INCOME,
        PaymentType.PAYMENT,
        PaymentType.WITHDRAW,
      ],
    },
    OrdersTable: {
      restrictByWorkPoint: true,
      hideAddButton: false,
      showDeleteButton: false,
      showDownloadButton: false,
    },
    GeneralInfo: {
      accessPayments: true,
      accessBooks: true,
    },
    ProductPanel: {
      restrictByWorkPoint: true,
    },
    VehicleForm: {
      restrictByWorkPoint: true,
    },
    CertificateExamsTable: {
      restrictByWorkPoint: true,
    },
    OrderForm: {
      paymentMethods: [PaymentMethods.CASH, PaymentMethods.POS],
    },
    ClassesTable: {
      restrictByWorkPoint: true,
    },
    CarDocumentsExpiration: {
      restrictByWorkPoint: true,
    },
    DocumentsManager: {
      delete: false,
    },
    HoursPanel: {
      addSupplementaryHours: true,
    },
    InstructorsTable: {
      showAllEmployees: true,
    },
  },
  Instructor: {
    MainHeader: {
      get data() {
        return getMainSliderDataForInstructors();
      },
    },
    MainSlider: {
      get data() {
        return getMainSliderDataForInstructors();
      },
    },
    LocalRouter: InstructorRouter,
    HoursPanel: {
      addHours: true,
      addSupplementaryHours: false,
      isInstructor: true,
    },
    GeneralInfo: {
      accessPayments: false,
    },
    ClientPanel: {
      restrictAccess: true,
      showEditClientButton: false,
    },
    StatusPanel: {
      excludedStatuses: [OrderStatuses.FINALIZAT_NECONFORM],
    },
    OrdersTable: {
      hideAddButton: true,
      excludedOrderStatuses: [
        OrderStatuses.FINALIZAT,
        OrderStatuses.FINALIZAT_NECONFORM,
      ],
    },
    DrivingHoursCalendar: {
      isInstructor: true,
    },
    DocumentsManager: {
      delete: false,
      showGenerateDocumentButton: false,
      showPrintButton: false,
      hideDownloadButton: true,
      hidePrintButton: true,
      showManageTypesButton: false,
    },
  },
};

export const EWeekDays = [
  { name: "LUNI", value: 1 },
  { name: "MARTI", value: 2 },
  { name: "MIERCURI", value: 3 },
  { name: "JOI", value: 4 },
  { name: "VINERI", value: 5 },
  { name: "SAMBATA", value: 6 },
  { name: "DUMINICA", value: 0 },
];

export const emailTemplateAdditionalData = {
  "order.Number": "Număr comandă",
  "client.firstName": "Nume client",
  "client.lastName": "Prenume client",

  "client.email": "Email client",
};

/**
 * responsive design resolution breakpoints
 */
export const ResolutionBreakPoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 1200,
  xl: 1200,
  xxl: 1400,
};

export const WhatsAppTemplateButtons = [
  {
    name: Vocabulary.quickReply,
    menu: [
      {
        name: Vocabulary.custom,
        content: {
          type: "QUICK_REPLY",
          text: "",
        },
      },
    ],
    shouldRenderDivider: true,
  },
  {
    name: Vocabulary.specificAction,
    menu: [
      {
        name: Vocabulary.visitSite,
        buttonNr: 2,
        content: {
          type: EWhatsAppTemplateButtonType.URL,
          text: "",
          url: "",
          example: [],
        },
      },
      {
        name: Vocabulary.callPhoneNumber,
        buttonNr: 1,
        content: {
          type: EWhatsAppTemplateButtonType.PHONE_NUMBER,
          text: "",
          phone_number: "",
        },
      },
    ],
  },
];

export const DefaultWhatsAppTemplateComponents = [
  {
    type: EWhatsAppComponentsTypes.HEADER,
    format: "NONE",
  },
  {
    type: EWhatsAppComponentsTypes.BODY,
    text: "",
  },
  {
    type: EWhatsAppComponentsTypes.FOOTER,
    text: "",
  },
  {
    type: EWhatsAppComponentsTypes.BUTTONS,
    buttons: [],
  },
];

export const WhatsappMessageStatuses: any = {
  sent: {
    name: "Trimis",
    icon: <Check fontSize="small" />,
  },
  delivered: {
    name: "Livrat",
    icon: <DoneAll fontSize="small" />,
  },
  read: {
    name: "Citit",
    icon: <DoneAll sx={{ color: "#2196f3" }} fontSize="small" />,
  },
  pending: {
    name: "În așteptare",
    icon: <HourglassBottom fontSize="small" />,
  },
  failed: {
    name: "Eșuat",
    icon: <PriorityHigh fontSize="small" />,
  },
};

export const IconsForNotes: any = {
  SYSTEM: {
    name: "SYSTEM",
    label: "System",
    icon: <SettingsIcon />,
    backgroundColor: "#3d6f6c",
  },
  EMAIL: {
    name: "EMAIL",
    label: "Email",
    icon: <Email />,
    backgroundColor: "#3d6f6c",
  },
  PHONE: {
    name: "PHONE",
    label: "Phone",
    icon: <Phone />,
    backgroundColor: "#3d6f6c",
  },
  SMS: {
    name: "SMS",
    label: "Sms",
    icon: <Sms />,
    backgroundColor: "#3d6f6c",
  },
  USER: {
    name: "USER",
    label: "User",
    icon: <Person />,
    backgroundColor: "#3d6f6c",
  },
  OTHERS: {
    name: "OTHERS",
    label: "Others",
    icon: <MiscellaneousServices />,
    backgroundColor: "#3d6f6c",
  },
};

export const WhatsAppTemplateStatuses: any = {
  APPROVED: ETemplateStatus.APPROVED,
  PENDING: ETemplateStatus.PENDING,
  REJECTED: ETemplateStatus.REJECTED,
};

export const WhatsAppTemplateIconsStatuses: any = {
  APPROVED: <ThumbUp />,
  PENDING: <Pending />,
  REJECTED: <ThumbDown />,
};

export const WhatsAppTemplateChipColors: any = {
  APPROVED: "#E1F0DA",
  PENDING: "#BED7DC",
  REJECTED: "#FF9B9B",
};

export const WhatsAppTemplateCategory: any = {
  AUTHENTICATION: EWhatsAppTemplateCategoryTranslation.AUTHENTICATION,
  MARKETING: EWhatsAppTemplateCategoryTranslation.MARKETING,
  UTILITY: EWhatsAppTemplateCategoryTranslation.UTILITY,
};

export const WhatsAppTemplatesSupportedLanguagesTranslation: any = {
  ro: "Română",
  en_US: "Engleză (US)",
  en_GB: "Engleză (GB)",
};

export const tableTheme: any = (defaultTheme: any) =>
  createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            "&:after": {
              borderBottom: "2px solid #3d6f6c !important",
            },
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            backgroundColor: "#3d6f6c !important",
            color: "#fff !important",
          },
        },
      },

      MuiPaper: {
        styleOverrides: {
          root: {
            [defaultTheme.breakpoints.down("md")]: {
              // marginTop: 50,
            },
          },
        },
      },

      MuiButtonBase: {
        styleOverrides: {
          root: {
            [defaultTheme.breakpoints.down("md")]: {
              marginTop: 4,
            },
          },
        },
      },
      MUIDataTableToolbar: {
        styleOverrides: {
          actions: {
            display: "flex",
            flexDirection: "row-reverse",
          },
          root: {
            [defaultTheme.breakpoints.down("md")]: {
              borderTopLeftRadius: "0px !important",
              borderTopRightRadius: "0px !important",
              display: "flex",
              textAlign: "center",
              backgroundColor: "#ededef !important",
              zIndex: 200,
              padding: 10,
            },
          },
        },
      },

      MuiIconButton: {
        styleOverrides: {
          root: {
            "&:hover": {
              color: "#3d6f6c",
            },
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: "rgb(64, 74, 105, 0.3)",
            borderTopRightRadius: "5px",
            borderTopLeftRadius: "5px",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: "rgb(64, 74, 105, 0.1)",
            fontWeight: 800,
          },
          root: {
            padding: "7px !important",
            paddingLeft: "25px !important",
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          toolbar: {
            backgroundColor: "#FFF",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: "#FFF",
            color: "#000",
            borderRadius: "50px",
            "&:hover": {
              backgroundColor: "#fff",
              color: "#3d6f6c",
            },
            [defaultTheme.breakpoints.down("md")]: {
              marginTop: 5,
            },
          },
        },
      },
    },
  });

export const WhatsAppTemplatesSupportedLanguages = ["ro", "en_US", "en_GB"];

export const FormsIds = {
  phoneNumber: "phoneNumber",
  verifyCodeForm: "verifyCodeForm",
  twoFactorAuthentication: "twoFactorAuthentication",
  importClientsForm: "importClientsForm",
  clients: "clients",
  clientsCategory: "clientsCategory",
  contactEmailForm: "contactEmailForm",
  billingDocumentsForm: "billingDocumentsForm",
  orderForm: "orderForm",
  orderSettingsNumber: "orderSettingsNumber",
  editOrderSettings: "editOrderSettings",
  usersForm: "usersForm",
  orderOfferForm: "orderOfferForm",
  editEmailTemplateForm: "editEmailTemplateForm",
  whatsAppTemplateForm: "whatsAppTemplateForm",
  whatsAppSettingsForm: "whatsAppSettingsForm",
  chatListForm: "chatListForm",
  noteForm: "noteForm",
  taskForm: "taskForm",
  alertForm: "alertForm",
  workPointForm: "workPointForm",
  companyForm: "companyForm",
  vehicleForm: "vehicleForm",
  instructorForm: "instructorForm",
  productForm: "productForm",
  classForm: "classForm",
  hours: "hoursForm",
  addNewProductToClient: "addNewProductToClientForm",
  collectPayment: "collectPayment",
  accountForm: "accountForm",
  salaryForm: "salaryForm",
  withdrawMoneyForm: "withdrawMoneyForm",
  examHours: "examHours",
  moduleForm: "moduleForm",
  examSetForm: "examSetForm",
  examQuestionForm: "examQuestionForm",
  certificateExamForm: "certificateExamForm",
  bookForm: "bookForm",
  sellBookForm: "sellBookForm",
  onlineLessonForm: "onlineLessonForm",
  documentTemplateForm: "documentTemplateForm",
  subscriptionForm: "subscriptionForm",
  documentsForm: "documentsForm",
  notificationForm: "notificationForm",
  myAccountForm: "myAccountForm",
  employeeDocumentsForm: "employeeDocumentsForm",
};

export const TablesIds = {
  logs: "logs",
  orders: "orders",
  clients: "clients",
  products: "products",
  emailTemplates: "emailTemplates",
  users: "users",
  contacts: "contacts",
  clientCategories: "clientCategories",
  tasks: "tasks",
  alerts: "alerts",
  workPoints: "workPoints",
  company: "company",
  vehicle: "vehicle",
  instructor: "instructor",
  product: "product",
  classes: "classes",
  accountsTable: "accountsTable",
  examsTable: "examsTable",
  drivingHoursInstructorTable: "drivingHoursInstructorTable",
  subscriptions: "subscriptions",
  documentsForm: "documentsForm",
  DOCUMENT_VALIDITY_PERSONAL: "documentValidityPersonal",
  DOCUMENT_VALIDITY_VEHICLE: "documentValidityVehicle",
};

export const RegisterWhatsAppPhoneNumberSteps = [
  {
    label: Vocabulary.registerPhoneNumber,
    component: <PhoneNumberRegistrationStep />,
    formName: FormsIds.phoneNumber,
  },
  {
    label: Vocabulary.verifyPhoneNumberRegistrationCode,
    component: <VerifyCodeConfirmationStep />,
    formName: FormsIds.verifyCodeForm,
  },
  {
    label: Vocabulary.setPinForTwoStepVerification,
    component: <TwoFactorAuthenticationSetupStep />,
    formName: FormsIds.twoFactorAuthentication,
  },
];

export const WhatsAppTemplatePropertyTags = [
  { label: "Nume client", value: "name" },
  { label: "Total comandă", value: "total" },
  { label: "Număr comandă", value: "number" },
  { label: "Link comandă", value: "orderLink" },
  { label: "Parolă", value: "password" },
  {
    label: "Nume persoană de contact",
    value: "contactPerson.firstName",
  },
  {
    label: "Prenume persoană de contact",
    value: "contactPerson.lastName",
  },
  {
    label: "Email persoană de contact",
    value: "contactPerson.email",
  },
  {
    label: "Telefon persoană de contact",
    value: "contactPerson.phone",
  },
  {
    label: "Status comandă",
    value: "status.name",
  },
];

export const LogFiltersMethods = [
  EAuditAction.CREATE,
  EAuditAction.UPDATE,
  EAuditAction.DELETE,
  EAuditAction.SOFT_DELETE,
  EAuditAction.IMPORT,
  EAuditAction.DUPLICATE,
];

export const LogFiltersStatuses = [
  EAuditStatus.ERROR,
  EAuditStatus.SUCCESS,
  EAuditStatus.INFO,
];

export const ImageExtensions = {
  "image/*": [".png", ".jpeg", ".jpg", ".svg"],
};

export const DocumentExtensions = {
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    ".pptx",
  ],
  "text/plain": [".txt"],
  "text/csv": [".csv"],
};

export const DocumentExtensionsArray = [
  ".doc",
  ".docx",
  ".pdf",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".txt",
  ".csv",
];

export const MessagesAttachmentsOptions = [
  {
    label: Vocabulary.image,
    type: EWhatsAppMessageType.IMAGE,
    icon: <Image />,
    accept: ".png, .jpeg, .jpg",
  },
  {
    label: Vocabulary.document,
    type: EWhatsAppMessageType.DOCUMENT,
    icon: <AttachFile />,
    accept: DocumentExtensionsArray.join(","),
  },
];

export const RuleOptions: { label: string; value: string }[] = [
  {
    label: "< (mai mic)",
    value: "<",
  },
  {
    label: "<= (mai mic sau egal)",
    value: "<=",
  },
  {
    label: "> (mai mare)",
    value: ">",
  },
  {
    label: ">= (mai mare sau egal)",
    value: ">=",
  },
  {
    label: "= (egal)",
    value: "=",
  },
];

export const GenericExcludedFields = [
  "_id",
  "createdAt",
  "updatedAt",
  "deleted_at",
  "__v",
];

export const GenericSettings = {
  drivingHourInterval: 90, //minutes
  timeIntervalToDeleteDrivingHour: 14, //in hours
  minHour: 6, //minimum hour for driving schedule (6 AM)
  maxHour: 22, //maximum hour for driving schedule (10 PM)
};

export const HoursTypes = {
  driving: "driving",
  exam: "exam",
};

export const DRIVING_LESSON_NOTIFICATION_TYPES = {
  LESSON_BOOKING_REQUEST: "lesson_booking_request",
  LESSON_APPROVED_BY_INSTRUCTOR: "lesson_approved_by_instructor",
  LESSON_REJECTED_BY_INSTRUCTOR: "lesson_rejected_by_instructor",
  LESSON_CANCELED_BY_CLIENT: "lesson_canceled_by_client",
  LESSON_CANCELED_BY_INSTRUCTOR: "lesson_canceled_by_instructor",
  LESSON_REMINDER: "lesson_reminder",
};

export const ENDPOINTS_SKIP_WORK_POINT_ID = {
  certificateExamsClientsAssigned: `${endpoints.exams.certificateExams}/clients/assigned`,
  certificateExams: `${endpoints.exams.certificateExams}`,
};

export const ENDPOINTS_SKIP_INSTRUCTOR_ID = {
  login: endpoints.login,
  instructorUser: endpoints.instructor.user,
};

export const RomanianCounties = [
  { code: 1, name: "Alba" },
  { code: 3, name: "Arad" },
  { code: 2, name: "Arges" },
  { code: 4, name: "Bacau" },
  { code: 5, name: "Bihor" },
  { code: 6, name: "Bistrita-Nasaud" },
  { code: 7, name: "Botosani" },
  { code: 9, name: "Braila" },
  { code: 8, name: "Brasov" },
  { code: 40, name: "Bucuresti" },
  { code: 10, name: "Buzau" },
  { code: 51, name: "Calarasi" },
  { code: 11, name: "Caras-Severin" },
  { code: 12, name: "Cluj" },
  { code: 13, name: "Constanta" },
  { code: 14, name: "Covasna" },
  { code: 15, name: "Dambovita" },
  { code: 16, name: "Dolj" },
  { code: 17, name: "Galati" },
  { code: 52, name: "Giurgiu" },
  { code: 18, name: "Gorj" },
  { code: 19, name: "Harghita" },
  { code: 20, name: "Hunedoara" },
  { code: 21, name: "Ialomita" },
  { code: 22, name: "Iasi" },
  { code: 23, name: "Ilfov" },
  { code: 26, name: "Maramures" },
  { code: 25, name: "Mehedinti" },
  { code: 24, name: "Mures" },
  { code: 27, name: "Neamt" },
  { code: 28, name: "Olt" },
  { code: 29, name: "Prahova" },
  { code: 31, name: "Salaj" },
  { code: 30, name: "Satu-Mare" },
  { code: 32, name: "Sibiu" },
  { code: 33, name: "Suceava" },
  { code: 36, name: "Teleorman" },
  { code: 35, name: "Timis" },
  { code: 34, name: "Tulcea" },
  { code: 38, name: "Valcea" },
  { code: 39, name: "Vaslui" },
  { code: 37, name: "Vrancea" },
];

export const ExternalLinks = {
  theoreticalExamSchedulingBase:
    "https://dgpci.mai.gov.ro/drpciv-booking/formular",
  addInArr: "https://www.raportarionlinearr.ro/rap_sca/crs_index.php",
  addInArrCertificate:
    "https://examinari.arr.ro/inscriere/MemberPages/InscriereCandidat.aspx",
};

export const ONLINE_PAYMENT = "Online";
